export default {
  condition: {
    id: 'live_shopping_product_card_condition',
    defaultMessage: '{grade} condition',
  },
  seeProduct: {
    id: 'live_shopping_product_card_see_product',
    defaultMessage: 'See product: {title}',
  },
  flashSalesTag: {
    id: 'live_shopping_product_card_flash_sales_tag',
    defaultMessage: 'Flash deal',
  },
  sellerFlashSalesTag: {
    id: 'live_shopping_product_card_seller_flash_sales_tag',
    defaultMessage: 'Price drop',
  },
  addToCart: {
    id: 'live_shopping_product_card_add_to_cart',
    defaultMessage: 'Add to cart',
  },
}
